export default {"src":"/_next/static/media/done.d4f43d93.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};